<template>
  <div class="summary white-box position-relative" v-if="loading || datas.length > 2">
    <TileLoader :loading="loading"/>
    <div>
      <h2>Suivi des GRFA</h2>
      <div v-if="period.declarationType == 3">
        <p>
          {{ period.label }} {{ period.year }}
        </p>
        <select :value="concept" @change="updateConcept($event.target.value)">
          <option :value="1">CMEM</option>
          <option :value="2">MME</option>
          <option :value="4">WA</option>
        </select>
      </div>
      <select v-else :value="period.id"
              @change="updatePeriod($event.target.value)"
              class="period-select"
      >
        <option
          v-for="p of detailedPeriods.filter(dp => dp.declarationType == 2 &&
          [2, 4].includes(dp.rfaPaymentFrequency) &&
          dp.year == period.year)"
          :value="p.id"
          :key="p.id"
        >
          {{ p.label }} {{ p.year }}
        </option>
      </select>
    </div>
    <div class="table-container">
      <table class="datas-table">
        <thead>
        <th></th>
        <th v-for="grfa of datas" :key="grfa.label">{{ grfa.label }}</th>
        </thead>
        <tbody>
        <tr>
          <td>Total fournisseur</td>
          <td v-for="grfa of datas" :key="grfa.label">{{grfa.nbSuppliers}}</td>
        </tr>
        <tr>
          <td>BAR Facturé</td>
          <td v-for="grfa of datas" :key="grfa.label">{{grfa.nbInvoiced}} <small class="text-muted" v-if="formatPercent(grfa.nbInvoiced, grfa.nbSuppliers)">({{formatPercent(grfa.nbInvoiced, grfa.nbSuppliers)}})</small></td>
        </tr>
        <tr>
          <td>Payé</td>
          <td v-for="grfa of datas" :key="grfa.label">{{grfa.nbPaid}} <small class="text-muted" v-if="formatPercent(grfa.nbPaid, grfa.nbSuppliers)">({{formatPercent(grfa.nbPaid, grfa.nbSuppliers)}})</small></td>
        </tr>
        <tr>
          <td>Versé</td>
          <td v-for="grfa of datas" :key="grfa.label">{{grfa.nbRemitted}} <small class="text-muted" v-if="formatPercent(grfa.nbRemitted, grfa.nbSuppliers)">({{formatPercent(grfa.nbRemitted, grfa.nbSuppliers)}})</small></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TileLoader from "@/components/Dashboards/TileLoader.vue";
import store from "@/store/dashboards";
import {getSuiviGrfa} from "@/utils/dashboardGrfa";

export default {
  components: {TileLoader},
  name: "SuiviGrfaTile",
  props: {
    pDatas: Array,
    pLoading: Number,
    period: {
      type: Object,
      required: true
    },
    concept: Number,
    detailedPeriods: Array
  },
  data() {
    return {
      datas: [],
      loading: 0,
      store
    }
  },
  mounted() {
    if (this.pDatas) {
      this.datas = this.formatData(this.pDatas);
    }
    if (this.pLoading) {
      this.loading = this.pLoading;
    }
    this.initData();
  },
  computed: {
    storeGlobalView() {
      return this.store.globalView;
    }
  },
  watch: {
    period(newVal) {
      this.initData();
    },
    storeGlobalView() {
      this.initData();
    },
    concept(newVal) {
      this.initData();
    },
    pLoading(newVal) {
      if (newVal) {
        this.loading = 1;
      } else {
        this.loading = 0;
      }
    },
    pDatas(newData) {
      this.datas = this.formatData(newData);
    },
  },
  methods: {
    updatePeriod(newPeriodId) {
      let newPeriod = this.detailedPeriods.find(dp => dp.id == newPeriodId);

      if (newPeriod)
        this.$emit('period-change', newPeriod);
    },
    updateConcept(newConceptId) {
      this.$emit('concept-change', parseInt(newConceptId));
    },
    initData() {
      // On n'initialise pas les données si déjà reçues depuis les props par exemple ou si en train de charger à l'extérieur
      if ((this.pDatas && this.pDatas.length > 0) || this.pLoading) return;
      if (!this.period) return;

      this.loading = 1;

      getSuiviGrfa(this.period.id, this.concept, this.storeGlobalView, false).then(res => {
        this.datas = this.formatData(res);
        this.loading = 0;
      })
    },
    formatData(datas) {
      let defaultValue = {
        nbSuppliers: 0,
        nbInvoiced: 0,
        nbPaid: 0,
        nbRemitted: 0
      }

      let result = {"total": {...defaultValue}};

      for (let row of datas) {
        if (!result[row.Grfa])
          result[row.Grfa] = {...defaultValue};

        result[row.Grfa].nbSuppliers += 1;
        result["total"].nbSuppliers += 1;

        if (row.Status >= 1) {
          result[row.Grfa].nbInvoiced += 1;
          result["total"].nbInvoiced += 1;
        }
        if (row.Status >= 2) {
          result[row.Grfa].nbPaid += 1;
          result["total"].nbPaid += 1;
        }
        if (row.Status >= 3) {
          result[row.Grfa].nbRemitted += 1;
          result["total"].nbRemitted += 1;
        }
      }
      let arrayResult = []
      let keys = Object.keys(result).filter(k => k !== "total").sort()
      for (let key of keys) {
        arrayResult.push({label: key, ...result[key]});
      }
      arrayResult.push({label: "Total", ...result["total"]})

      return arrayResult;
    },
    formatPercent(base, total) {
      if (!total) return "";
      return (Math.round((base / total) * 1000) / 10) + " %";
    }
  }
}
</script>

<style scoped>
.white-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  flex-basis: 40em;
}

.white-box p {
  margin: 0;
}

.summary h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.table-container {
  max-height: 23em;
  overflow: auto;
}

.datas-table {
  width: 100%;
}

.datas-table thead {
  border-bottom: 1px solid black;
}

.datas-table th, .datas-table td {
  padding: 2px 8px;
}

.datas-table tbody tr:nth-child(odd) {
  background-color: #EFEFEF;
}

.datas-table tbody tr:nth-child(even) {
  background-color: #C5C5C5;
}

.datas-table a {
  color: inherit;
  text-decoration: none;
}

.datas-table td.with-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
}

.datas-table .number {
  text-align: right;
  vertical-align: baseline;
}

.datas-table .tag > div {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.datas-table .tag > div.green {
  background-color: #388E3C;
}

.datas-table .tag > div.orange {
  background-color: #FFC107;
}

.datas-table .tag > div.red {
  background-color: #D32F2F;
}

.trend-indicator {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  font-size: 0.8em;
}

.trend-indicator.up {
  color: #388E3C;
}

.trend-indicator.up::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23388E3C%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%2017l6-6l4%204l8-8%22%2F%3E%3Cpath%20d%3D%22M17%207h4v4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}

.trend-indicator.down {
  color: #D32F2F;
}

.trend-indicator.down::before {
  content: url('data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20fill%3D%22none%22%20stroke%3D%22%23D32F2F%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%3E%3Cpath%20d%3D%22m3%207l6%206l4-4l8%208%22%2F%3E%3Cpath%20d%3D%22M17%2017h4v-4%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardGRFA/SuiviGrfaTile.vue